import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterFlowService {

  private isRedirected = new BehaviorSubject<any>(false);

  constructor() { }

  sendRedirectInfo(): any {
    this.isRedirected.next(true);
  }

  getRedirectInfo(): Observable<any> {
    return this.isRedirected.asObservable();
  }
}
